import { useRoles } from '../roles/RolesContext';
import { selectKeystoneAccess } from '../roles/deriveRoles';

export interface KeystoneAccess {
  isMember: boolean;
  isLeader: boolean;
  isLoading: boolean;
}

// Determines what the current user can do inside the Keystone module.
// Backed by the session roles context (#13), which calls the
// is_keystone_member / is_keystone_leader SQL helpers once per session;
// loading state is exposed so UIs can render skeletons rather than flashing
// inaccessible content.
export function useKeystoneAccess(): KeystoneAccess {
  const roles = useRoles();
  return { ...selectKeystoneAccess(roles), isLoading: roles.loading };
}
